<template>
  <el-dialog
    :close-on-click-modal="false"
    title="手动选择匹配（温馨提示：超过12元的ETC消费金额，手动匹配的情况下，需要审核才能正式生效）"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="1100px"
  >
    <section>
      <TableBox ref="tableBox" :isRadio="true" />
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="sub" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  etcMatch,
} from 'api/service';
import TableBox from './tableBox';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      merLoading: false, // 商户选项loading中
      originData: {},
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.originData = item;
      this.$nextTick(() => {
        this.$refs.tableBox.saveSearchBoxData({
          etcId: item.etcId,
        });
      });
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub () {
      const orderId = this.$refs.tableBox.tableData.chooseRadio;
      if (!orderId) {
        this.$message.warning('请选择匹配订单');
        return;
      }
      this.subLoading = true;
      const res = await etcMatch({
        etcId: this.originData.etcId,
        orderId,
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '匹配成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
